<template>
  <div class="rounded-md bg-surface-primary h-full">
    <div
      v-if="$slots.header"
      class="rounded-t-md"
      :class="[headerClass, `${paddingY} ${paddingX}`]"
    >
      <slot name="header" />
    </div>
    <div :class="[`${paddingY} ${paddingX}`]">
      <slot />
    </div>
  </div>
</template>

<script lang="ts" setup>
interface Props {
  headerClass?: string;
  paddingY?: string;
  paddingX?: string;
}

withDefaults(defineProps<Props>(), {
  headerClass: 'bg-surface-highlight',
  paddingY: 'py-24',
  paddingX: 'px-16',
});
</script>

<style scoped></style>
